import { baseApi } from "../app-main/store/baseApi";

export type UnsyncedCalendarSpacesResponse = {
  space_ids: string[];
};

/**
 * Returns space IDs whose calendars are not synced for the authenticated host.
 * Backed by `GET /v1/calendar/user/spaces/unsynced`.
 */
export const calendarApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUnsyncedCalendarSpaces: builder.query<
      UnsyncedCalendarSpacesResponse,
      void
    >({
      query: () => ({
        url: "/v1/calendar/user/spaces/unsynced",
      }),
    }),
  }),
});

export const { useGetUnsyncedCalendarSpacesQuery } = calendarApi;
